import { render, staticRenderFns } from "./BotKeyboardMsg.vue?vue&type=template&id=badcb676&scoped=true&lang=pug&"
import script from "./BotKeyboardMsg.vue?vue&type=script&lang=js&"
export * from "./BotKeyboardMsg.vue?vue&type=script&lang=js&"
import style0 from "./BotKeyboardMsg.vue?vue&type=style&index=0&id=badcb676&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badcb676",
  null
  
)

export default component.exports